import { lazy } from 'react';
import paths from '../paths';
import { createRoute } from 'constants/utils';

const Pages = lazy(() => import('../../components/pages/campaign/pages/Pages'));
const AddPage = lazy(() => import('../../components/pages/campaign/pages/AddPage/AddPage'));

export const campaignPageSettingsRoutes = (abilities) => {
  return {
    path: paths.getCampaignPageSettingsLayout,
    children: [
      createRoute(paths.pages, Pages),
      (abilities?.campaign?.read ?? false) && createRoute(paths.newPage(), AddPage),
      (abilities?.campaign?.read ?? false) && createRoute(paths.editPage(), AddPage),
    ],
  };
};
